import ObjectGroupsPage from '../pages/ObjectGroupsPage';
import ObjectGroupsSortPage from '../pages/ObjectGroupsSortPage';
import ObjectsPage from '../pages/ObjectsPage';
import SettlementsPage from '../pages/SettlementsPage';
import LoginPage from '../pages/LoginPage';
import ObjectGroupPage from '../pages/ObjectGroupPage';
import SettlementDetailsPage from '../pages/SettlementDetailsPage';
import SettlementUpdateBookingsPage from '../pages/SettlementUpdateBookingsPage';
import SettlementSendToOwnersPage from '../pages/SettlementSendToOwnersPage';
import ObjectMiscsPage from '../pages/ObjectMiscsPage';
import TransactionsPage from '../pages/TransactionsPage';
import SurveysPage from '@/pages/SurveysPage';
import SurveyQuestionsPage from '@/pages/SurveyQuestionsPage';
import SurveyResultPage from '@/pages/SurveyResultPage';
import UserSettingsPage from '../pages/UserSettingsPage';
import UsersPage from '@/pages/UsersPage';
import UserPage from '@/pages/UserPage';
import ObjectPage from '@/pages/ObjectPage';
import {BookingPageModes} from '@/pages/PageModes';
import BookingsPage from '@/pages/BookingsPage';
import BookingPage from '@/pages/BookingPage';
import MiscAccountsPage from "@/pages/MiscAccountsPage";
import GuestsPage from "@/pages/GuestsPage";
import GuestDetailsPage from "@/pages/GuestDetailsPage";
import ImportStayinPage from '@/pages/ImportStayinPage';
import StartPage from '../pages/StartPage';
import globalRoutes from './global-routes';
import NotificationsPage from '@/pages/NotificationsPage';
import DashboardPage from '@/pages/DashboardPage';
import SettlementPreviewPage from '@/pages/SettlementPreviewPage';

export default [
  ...globalRoutes,
  {
    path: '/',
    redirect: '/start'
  },
  {
    path: '/start',
    name: 'Start',
    component: StartPage
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: {
      permission: 'BOOKING_VIEW_DETAILS'
    }
  },
  {
    path: '/objekt-gruppen',
    name: 'ObjectGroupsPage',
    component: ObjectGroupsPage,
    meta: {
      permission: 'OBJECT_GROUP_VIEW'
    }
  },
  {
    path: '/objekt-gruppen-sortieren',
    name: 'ObjectGroupsSortPage',
    component: ObjectGroupsSortPage
  },
  {
    path: '/objekte/',
    name: 'ObjectsPage',
    component: ObjectsPage,
    meta: {
      permission: 'OBJECT_VIEW_DETAILS'
    }
  },
  {
    path: '/objekte/:objectId',
    name: 'ObjectPage',
    component: ObjectPage,
    props: true,
    meta: {
      permission: 'OBJECT_VIEW_DETAILS'
    }
  },
  {
    path: '/objektgruppe/:objectGroupId',
    name: 'ObjectGroupPage',
    component: ObjectGroupPage,
    props: (route) => {
      const objectGroupId = Number.parseInt(route.params.objectGroupId, 10)
      if (Number.isNaN(objectGroupId)) {
        return 0
      }
      return { objectGroupId }
    },
    meta: {
      permission: 'OBJECT_GROUP_EDIT'
    }
  },
  {
    path: '/objektgruppe/anlegen',
    name: 'ObjectGroupCreate',
    component: ObjectGroupPage,
    meta: {
      permission: 'OBJECT_GROUP_EDIT'
    }
  },
  {
    path: '/abrechnungen',
    name: 'Settlements',
    component: SettlementsPage,
    meta: {
      permission: 'SETTLEMENT_VIEW'
    }
  },
  {
    path: '/abrechnungen/:settlementId',
    name: 'SettlementDetails',
    component: SettlementDetailsPage,
    props: true,
    meta: {
      permission: 'SETTLEMENT_VIEW'
    }
  },
  {
    path: '/abrechnungen/vorschau',
    name: 'SettlementPreviewPage',
    component: SettlementPreviewPage,
    meta: {
      permission: 'SETTLEMENT_VIEW'
    }
  },
  {
    path: '/abrechnungen/:settlementId/buchungen',
    name: 'SettlementUpdateBookings',
    component: SettlementUpdateBookingsPage,
    props: true,
    meta: {
      permission: 'SETTLEMENT_EDIT'
    }
  },
  {
    path: '/abrechnungen/:settlementId/versenden',
    name: 'SettlementSendToOwners',
    component: SettlementSendToOwnersPage,
    props: true,
    meta: {
      permission: 'SETTLEMENT_EDIT'
    }
  },
  {
    path: '/zusatzrechnungen',
    name: 'ObjectMiscs',
    component: ObjectMiscsPage,
    meta: {
      permission: 'MISC_OBJECT_VIEW'
    }
  },
  {
    path: '/rückzahlungen',
    name: 'Transactions',
    component: TransactionsPage,
    meta: {
      permission: 'TRANSACTION_VIEW'
    }
  },
  {
    path: '/umfragen',
    name: 'Surveys',
    component: SurveysPage,
    meta: {
      permission: 'SURVEY_VIEW'
    }
  },
  {
    path: '/umfragen/bearbeiten',
    name: 'SurveyQuestions',
    component: SurveyQuestionsPage,
    meta: {
      permission: 'SURVEY_EDIT'
    }
  },
  {
    path: '/buchungen/:bookingId/umfrage',
    name: 'SurveyResultPage',
    component: SurveyResultPage,
    props: true,
    meta: {
      permission: 'SURVEY_VIEW'
    }
  },
  {
    path: '/benutzer',
    name: 'Users',
    component: UsersPage,
    meta: {
      permission: 'USER_VIEW'
    }
  },
  {
    path: '/benutzer/:userId',
    name: 'User',
    component: UserPage,
    props: (route) => {
      const userId = Number.parseInt(route.params.userId, 10)
      if (Number.isNaN(userId)) {
        return 0
      }
      return { userId }
    },
    meta: {
      permission: 'USER_EDIT'
    }
  },
  {
    path: '/benutzer/anlegen',
    name: 'UserCreate',
    component: UserPage,
    meta: {
      permission: 'USER_EDIT'
    }
  },
  {
    path: '/benutzereinstellungen',
    name: 'UserSettings',
    component: UserSettingsPage,
    meta: {
      permission: 'USER_EDIT'
    }
  },
  {
    path: '/konten',
    name: 'MiscAccounts',
    component: MiscAccountsPage,
    meta: {
      permission: 'MISC_ACCOUNT_VIEW'
    }
  },
  {
    path: '/gaeste',
    name: 'Guests',
    component: GuestsPage,
    meta: {
      permission: 'GUEST_VIEW'
    }
  },
  {
    path: '/gaeste/:guestId',
    name: 'GuestDetails',
    component: GuestDetailsPage,
    props: true,
    meta: {
      permission: 'GUEST_VIEW'
    }
  },
  {
    path: '/buchungen',
    name: 'Bookings',
    component: BookingsPage,
    meta: {
      permission: 'BOOKING_INDEX'
    }
  },
  {
    path: '/buchungen/anreisen',
    name: 'BookingsCheckIn',
    component: BookingsPage,
    props: {
      viewMode: BookingPageModes.CHECK_IN,
    },
    meta: {
      permission: 'BOOKING_INDEX'
    }
  },
  {
    path: '/buchungen/abreisen',
    name: 'BookingsCheckOut',
    component: BookingsPage,
    props: {
      viewMode: BookingPageModes.CHECK_OUT,
    },
    meta: {
      permission: 'BOOKING_INDEX'
    }
  },
  {
    path: '/buchungen/neue',
    name: 'BookingsOnlyNew',
    component: BookingsPage,
    props: {
      viewMode: BookingPageModes.ONLY_NEW,
    },
    meta: {
      permission: 'BOOKING_INDEX'
    }
  },
  {
    path: '/buchungen/:bookingId',
    name: 'BookingDetails',
    component: BookingPage,
    props: true,
    meta: {
      permission: 'BOOKING_VIEW'
    }
  },
  {
    path: '/imports/stayin',
    name: 'ImportStayin',
    component: ImportStayinPage,
    props: true,
    meta: {
      permission: 'BOOKING_EDIT'
    }
  },
  {
    path: '/nachrichten',
    name: 'Notifications',
    component: NotificationsPage,
    meta: {
      permission: 'NOTIFICATION_VIEW'
    }
  },
];
